import { apiSlice } from "../../apiSlice";

export const CreadoxxApiSlice = apiSlice.injectEndpoints({
  overrideExisting: true,
  endpoints: (builder) => ({
    createDo: builder.mutation({
      query: (parameters) => ({
        url: `/Modimpxx/Trackimp/Creadoxx`,
        method: "POST",
        body: parameters,
        headers: { 'modulecima': 'Modimpxx' },
      }),
      invalidatesTags: ["Create"],
    }),
    getGroupByPerfil: builder.query({
      query: (parameters) => ({
        url: `/Modimpxx/Trackimp/Creadoxx/getGroupByPerfil/${parameters.CLIIDXXX}`,
        method: "GET",
        headers: { 'modulecima': 'Modimpxx' },
      }),
    }),
    getDataTracking: builder.query({
      query: (parameters) => {
        let headers = {};
        headers['modulecima'] = parameters.MODURLXX.toLowerCase();
        return {
          url: `/${parameters.MODURLXX}/${parameters.PRODURLX}`,
          params: { ...parameters },
          headers: headers,
        };
      },
      providesTags: ["Create"],
    }),
  }),
});

export const {
  useCreateDoMutation,
  useLazyGetGroupByPerfilQuery,
  useGetDataTrackingQuery,
  useLazyGetDataTrackingQuery,
} = CreadoxxApiSlice;
